























































































































	// @ts-ignore
    import _ from './TeNavFrame.ts'; export default _;
